module.exports = __WEBPACK_EXTERNAL_MODULE_341__;


//////////////////
// WEBPACK FOOTER
// external {"root":["Rx","Observable"],"commonjs":"rxjs/observable/fromEvent","commonjs2":"rxjs/observable/fromEvent","amd":"rxjs/observable/fromEvent"}
// module id = 341
// module chunks = 0 1